<script>
    import app from "../stores/app";
    import {fade, fly} from 'svelte/transition';
    import {clickOutside} from "../js/clickOutside";
    import {createEventDispatcher} from 'svelte/internal';
    import CloseButton from "./CloseButton.svelte";

    export let title = '';
    export let modalMd = false;
    // export let modalXl = false;

    export let md = false;
    export let xl = false;
    // export let wrapContent = false;
    export let showCloseButton = true;
    export let closeOnClickOutside = false;
    export let closeOnEscape = true;
    export let visible = true;
    export let bodyClass = '';
    export let onBeforeClose = null;

    let nowState = false;

    const dispatch = createEventDispatcher();

    const handleClickOutside = () => {
        if (closeOnClickOutside) {
            close();
        }
    }

    const close = () => {
        let doClose = true;
        if (onBeforeClose != null) {
            doClose = onBeforeClose();
        }

        if (!doClose) {
            return;
        }

        visible = false;
        if (closeOnEscape) {
            app.removeEscapeEventHandler();
        }
        setTimeout(() => {
            dispatch('close');
        }, 200);
    }

    $: if (nowState != visible && closeOnEscape) {
        if (visible) {
            if (closeOnEscape) {
                app.addEscapeEventHandler(close);
            }
            nowState = visible;
        }
    }
</script>
{#if visible}
    <div class="modal-overlay" transition:fade="{{ duration: 100 }}" use:clickOutside
         on:click_outside="{ handleClickOutside }">
        <div class="wrapper" class:xl>
            <div class="modal-panel" class:md class:xl
                 in:fly="{{ y: -20, duration: 200 }}">
                <div class="panel-heading px-4 py-3">
                    <div class="title">
                        { title }
                    </div>
                    {#if showCloseButton}
                        <CloseButton size="{xl ? 'xl' : 'lg'}" on:click="{ close }"/>
                    {/if}
                </div>
                <div class="panel-body { bodyClass }">
                    <slot name="body"/>
                </div>
                <slot name="footer"/>
            </div>
        </div>
    </div>
{/if}

<style>
    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9000;
        overflow-y: auto;
    }

    .modal-overlay .wrapper {
        position: absolute;
        width: 100%;
        padding: 10px 0;
    }

    .modal-panel {
        width: max-content;
        background: #fff;
        border-radius: 2px;
        /*padding-top: 5px;*/
        transition: .3s all ease;
        margin: 0 auto;
        overflow: hidden;
    }

    .modal-panel .panel-heading {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 35px;
        background: #f7f7f7;
        border-bottom: 1px dashed #ededed;
        padding: 0 15px;
    }

    .modal-panel .panel-heading .title {
        font-size: 1.2rem;
        color: #6f6f6f;
    }

    .modal-panel .panel-body {
        position: relative;
        background: #fff;
    }

    /*.modal-panel .panel-body.wrap-content {*/
    /*    overflow-y: auto;*/
    /*    max-height: calc(100vh - 202px);*/
    /*}*/

    :global(.modal-panel .panel-footer) {
        border-top: 1px dashed #ededed;
    }


    .modal-overlay .wrapper.xl {
        padding: 10px;
    }

    .modal-panel.md {
        width: 600px;
        max-width: 100%;
    }

    .modal-panel.xl {
        width: 100%;
    }

    /*.modal-md {*/
    /*    width: 800px;*/
    /*}*/

    /*.modal-xl {*/
    /*    width: 100%;*/
    /*    min-height: calc(100vh - 20px);*/
    /*}*/

    @media (max-width: 576px) {
        .modal-panel {
            width: calc(100vw - 20px);
        }
    }

    @media (min-width: 768px) and (max-width: 991px) {
        .modal-panel.md {
            width: calc(100% - 20px);
        }
    }

    @media (min-width: 992px) {
        .modal-panel {
            min-width: 450px;
        }
    }

    @media (min-width: 1200px) {
        .modal-overlay .wrapper {
            padding: 30px 0;
        }
    }
</style>